import React from 'react'
import ModuleCards from '../components/moduleCards'

function Modules() {
  return (
    <ModuleCards/>
  )
}

export default Modules